import React from 'react'

import './Footer.scss'

/**
 * Footer component. Pretty self explanatory.
 *
 * @component
 * @example
 * return (
 *   <Footer />
 * )
*/

const Footer = () => {
    
    return (
        <footer className="footer bg-secondary fixed-bottom mt-auto py-3">

            <div className="container">

                <div className="w-100 d-flex justify-content-center justify-content-sm-start">

                    <span className="copyright-text text-white">
                        &copy; Zeal Innovations, 2022. All Rights Reserved.
                    </span>


                </div>

            </div>

        </footer>
    )

}

export default Footer;